
/* injects from baggage-loader */
require('./style.styl');

import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {addIntegration, fetchIntegrations} from 'redux/modules/integrations/actions'
import PromptContainer from 'components/PromptContainer'
import FormInput from 'components/FormInput'
import FormSelect from 'components/FormSelect'
import DatePicker from 'components/DatePicker'
import currencies from 'utils/currencies'
import {Field, reduxForm, formValueSelector, SubmissionError} from 'redux-form'
import ButtonsGroup from 'components/ButtonsGroup'
import moment from 'moment'
import {channelGroups as groups} from '@divvit/common-channels'

const costConnectorFields = {
  'fixed-cost': ['amount', 'currency', 'period'],
  'cost-per-visit': ['amount', 'currency'],
  'cost-per-order': ['amount', 'currency'],
  'revenue-share': ['amount'],
  'marketing-share': ['amount']
}

export class IntegrationsNewManualInput extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    today: PropTypes.object,
    change: PropTypes.func,
    selectedType: PropTypes.string,
    selectedStartDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    selectedEndDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
  }

  render() {
    const {
      handleSubmit,
      submitting
    } = this.props

    return (
      <PromptContainer className='report-add-view' title='Add new manual cost calculation'>
        <form className='manual-integration_form' onSubmit={handleSubmit}>
          <div className='manual-integration_form_type'>
            <Field
              className='manual-integration_form_input'
              label='Integration name'
              name='name'
              disabled={submitting}
              component={FormInput}
            />
            <Field
              className='manual-integration_form_select'
              label='Cost type'
              name='integrationType'
              disabled={submitting}
              component={FormSelect}
              emptyValue='Please select cost type'
              options={[
                {name: 'Fixed Cost', value: 'fixed-cost'},
                {name: 'Cost per visit', value: 'cost-per-visit'},
                {name: 'Cost per conversion', value: 'cost-per-order'},
                {name: 'Revenue Share', value: 'revenue-share'},
                {name: 'Marketing Share', value: 'marketing-share'}
              ]}
            />
          </div>
          {this.renderFields()}
          {this.renderActions()}
        </form>
      </PromptContainer>
    )
  }

  renderFields() {
    const {selectedType, selectedStartDate, selectedEndDate, submitting, today} = this.props

    if (!selectedType) return null

    return (
      <Fragment>
        <div className='manual-integration_form_fields'>
          {costConnectorFields[selectedType]
            .map((field, index) => this[`render${field[0].toUpperCase()}${field.substr(1)}`](index))}
        </div>
        <div className='manual-integration_form_datepickers'>
          <div className='manual-integration_form_datepicker'>
            <div className='manual-integration_form_datepicker_label'>Start Date</div>
            <DatePicker
              className='manual-integration_datepicker'
              disabled={submitting}
              today={today}
              startDate={selectedStartDate}
              endDate={today}
              maxDate={moment(today).clone().add(1, 'year').toDate()}
              modes={['single']}
              onSelect={value => this.props.change('integrationStartDate', value)}
            />
          </div>
          <div className='manual-integration_form_datepicker'>
            <div className='manual-integration_form_datepicker_label'>End Date</div>
            <DatePicker
              className='manual-integration_datepicker'
              disabled={submitting}
              today={today}
              startDate={selectedEndDate}
              endDate={today}
              maxDate={moment(today).clone().add(1, 'year').toDate()}
              modes={['single']}
              onSelect={value => this.props.change('integrationEndDate', value)}
            />
          </div>
        </div>
      </Fragment>
    )
  }

  renderLabelForAmount(selectedType) {
    switch (selectedType) {
      case 'revenue-share':
        return 'Percent per conversion'
      case 'marketing-share':
        return 'Percent per cost'
      default:
        return 'Amount'
    }
  }

  renderAmount(key) {
    const {submitting, selectedType} = this.props

    return (
      <div className='manual-integration_form_amount' key={key}>
        <Field
          className='manual-integration_form_input'
          name='amount'
          placeholder='100'
          disabled={submitting}
          component={FormInput}
          label={this.renderLabelForAmount(selectedType)}
        />
      </div>
    )
  }

  renderCurrency(key) {
    const {submitting} = this.props

    return (
      <div className='manual-integration_form_currency' key={key}>
        <Field
          className='manual-integration_form_select'
          name='currency'
          searchable
          disabled={submitting}
          component={FormSelect}
          label='Currency'
          options={currencies.map(({value}) => ({name: value, value: value}))}
        />
      </div>
    )
  }

  renderPeriod(key) {
    const {submitting, today} = this.props

    return (
      <div className='manual-integration_form_timeperiod' key={key}>
        <Field
          className='manual-integration_form_select'
          name='period'
          disabled={submitting}
          component={FormSelect}
          label='Time Period'
          options={[
            {name: 'Daily', value: 'day'},
            {name: 'Weekly', value: 'week'},
            {name: 'Monthly', value: 'month'},
            {name: 'Yearly', value: 'year'}
          ]}
          onChange={(evt, value) => {
            switch (value) {
              case 'day':
                return this.props.change('integrationEndDate', moment(today).clone().add(1, 'day').toDate())
              case 'week':
                return this.props.change('integrationEndDate', moment(today).clone().add(1, 'week').toDate())
              case 'month':
                return this.props.change('integrationEndDate', moment(today).clone().add(1, 'month').toDate())
              case 'year':
                return this.props.change('integrationEndDate', moment(today).clone().add(1, 'year').toDate())
              default:
                return this.props.change('integrationEndDate', today)
            }
          }}
        />
      </div>
    )
  }

  renderActions() {
    const {invalid, submitting, closeModal} = this.props

    return (
      <ButtonsGroup className='manual-integration_actions' align='right'>
        <button
          className='button is-transparent manual-integration_action'
          type='button'
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          type='submit'
          className='button manual-integration_action manual-integration_form_submit'
          disabled={submitting || invalid}
        >
          Add cost calculation
        </button>
      </ButtonsGroup>
    )
  }
}

const selector = formValueSelector('integrationsManualIntegration')
const mapStateToProps = (state, {currentSite, channel: {channelGroupId, channelId}}) => {
  const groupName = groups[channelGroupId].label
  const channelName = groups[channelGroupId].channels[channelId].label
  return {
    merchantSite: currentSite,
    selectedStartDate: selector(state, 'integrationStartDate'),
    selectedEndDate: selector(state, 'integrationEndDate'),
    selectedPeriod: selector(state, 'period'),
    selectedType: selector(state, 'integrationType'),
    initialValues: {
      currency: currentSite.currency,
      period: 'month',
      integrationStartDate: state.today,
      integrationEndDate: moment(state.today).clone().add(1, 'month').toDate(),
      name: `${groupName}/${channelName}, ${currentSite.name}`
    },
    today: state.today
  }
}

export default connect(mapStateToProps, {
  closeModal
})(reduxForm({
  form: 'integrationsManualIntegration',
  touchOnChange: true,
  validate: (values, {selectedType}) => {
    const errors = {}

    if (!selectedType) return {integrationType: true}

    const fields = costConnectorFields[selectedType]

    if (fields.includes('amount') && !values.amount) {
      errors.amount = 'Amount is required'
    }

    if (fields.includes('currency') && !values.currency) {
      errors.currency = 'Currency is required'
    }

    if (fields.includes('period') && !values.period) {
      errors.period = 'Period is required'
    }

    return errors
  },
  onSubmit: ({
    integrationType,
    integrationStartDate,
    integrationEndDate,
    name,
    amount,
    currency,
    period
  }, dispatch, {channel, merchantSite}) => new Promise((resolve, reject) => {
    const fields = costConnectorFields[integrationType]
    const options = {
      merchantSiteId: merchantSite.id,
      channel,
      integrationType,
      integrationStartDate,
      integrationEndDate,
      name,
      amount,
      currency
    }

    if (fields.includes('period') && period) {
      options.period = period
    }

    dispatch(addIntegration('manual-input', options))
      .success(() => {
        dispatch(closeModal())
        dispatch(fetchIntegrations())
        resolve()
      })
      .fail(err => {
        dispatch(closeModal())
        reject(new SubmissionError({_error: err}))
      })
  })
})(IntegrationsNewManualInput))



// WEBPACK FOOTER //
// ./client/modals/IntegrationsNewManualInput/index.js